module.exports = __webpack_public_path__ + "img/top_inside_reight.550b5838.svg";